import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeDifference',
  standalone: true,
  pure: true // pure: true ensures the pipe is only recalculated when input changes
})
export class TimeDifferencePipe implements PipeTransform {
  transform(startString: string, endString: string): string {

    const start = new Date(startString);
    const end  = new Date(endString);

    if (end.getFullYear() < 2000) {
      return 'Unknown';
    }

    const timeDiff = end.getTime() - start.getTime(); // Get the time difference in milliseconds

    // Convert milliseconds to days, hours, minutes, and seconds
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    // Generate the human-readable time difference string
    const timeParts: string[] = [];
    if (days > 0) {
      timeParts.push(`${days}d`);
    }
    if (hours > 0) {
      timeParts.push(`${hours}h`);
    }
    if (minutes > 0) {
      timeParts.push(`${minutes}m`);
    }
    if (seconds > 0) {
      timeParts.push(`${seconds}s`);
    }

    // Join the time parts with commas and 'and' for readability
    let formattedTime = '';
    if (timeParts.length === 1) {
      formattedTime = timeParts[0];
    } else if (timeParts.length > 1) {
      const lastPart = timeParts.pop();
      formattedTime = timeParts.join(', ') + ' and ' + lastPart;
    }

    return formattedTime;
  }
}
